"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsernameAuthViewContainer = void 0;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _UsernameAuthView = require("./UsernameAuthView");
var _source = require("../../selectors/source");
var _selectors = require("./selectors");
function mapStateToProps(state) {
  return {
    source: (0, _source.sourceSelector)(state),
    activeFlow: (0, _selectors.flowSelector)(state)
  };
}
const UsernameAuthViewContainer = exports.UsernameAuthViewContainer = (0, _reactRedux.connect)(mapStateToProps)(_UsernameAuthView.UsernameAuthView);